export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f11db53ffef11c9e52e2d7492f137195c0e6e88a0&name=fetchTypeahead!'